module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box box-info"
  }, [_c('DataTable', {
    ref: "po",
    staticClass: "p-datatable-responsive p-datatable-gridlines",
    attrs: {
      "value": _vm.dublicateSalesChildHeaderLists,
      "paginator": true,
      "rows": 100,
      "filters": _vm.filters,
      "rowsPerPageOptions": [100, 500, 1000],
      "data-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_c('Button', {
          attrs: {
            "icon": "pi pi-external-link",
            "label": "Export"
          },
          on: {
            "click": function($event) {
              return _vm.exportCSV($event)
            }
          }
        })], 1)]
      },
      proxy: true
    }, {
      key: "empty",
      fn: function() {
        return [_vm._v("No record found")]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('Column', {
    attrs: {
      "header": "S.N"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(sl) {
        return [_vm._v("\n                " + _vm._s(sl.index + 1) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Miti",
      "sortable": true,
      "field": "salesDateNepali",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['salesDateNepali']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'salesDateNepali', $$v)
            },
            expression: "filters['salesDateNepali']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Date",
      "sortable": true,
      "field": "salesDate",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['salesDate']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'salesDate', $$v)
            },
            expression: "filters['salesDate']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Time",
      "sortable": true,
      "field": "time",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['time']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'time', $$v)
            },
            expression: "filters['time']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Bill No",
      "sortable": true,
      "field": "billPrefix",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['billPrefix']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'billPrefix', $$v)
            },
            expression: "filters['billPrefix']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Customer",
      "sortable": true,
      "field": "customerName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['customerName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'customerName', $$v)
            },
            expression: "filters['customerName']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                Total:\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Contact",
      "sortable": true,
      "field": "contactNumber",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['contactNumber']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'contactNumber', $$v)
            },
            expression: "filters['contactNumber']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Address",
      "sortable": true,
      "field": "deliveryAddress",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['deliveryAddress']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'deliveryAddress', $$v)
            },
            expression: "filters['deliveryAddress']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Pay Status",
      "bodyStyle": "text-align: right",
      "field": "paymentStatus",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['paymentStatus']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'paymentStatus', $$v)
            },
            expression: "filters['paymentStatus']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Pay Method",
      "sortable": true,
      "field": "paymentMethod",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['paymentMethod']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'paymentMethod', $$v)
            },
            expression: "filters['paymentMethod']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Dis Amt",
      "bodyStyle": "text-align: right",
      "field": "discountAmount",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['discountAmount']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'discountAmount', $$v)
            },
            expression: "filters['discountAmount']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                " + _vm._s(_vm.totalDiscountAmount.toFixed(2)) + "\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Amount",
      "bodyStyle": "text-align: right",
      "field": "billAmount",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['billAmount']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'billAmount', $$v)
            },
            expression: "filters['billAmount']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                " + _vm._s(_vm.totalBillAmount.toFixed(2)) + "\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Counter",
      "bodyStyle": "text-align: right",
      "field": "counterName",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['counterName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'counterName', $$v)
            },
            expression: "filters['counterName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Store",
      "bodyStyle": "text-align: right",
      "field": "warehouseName",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['warehouseName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'warehouseName', $$v)
            },
            expression: "filters['warehouseName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Entered By",
      "bodyStyle": "text-align: right",
      "field": "enteredBy",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['enteredBy']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'enteredBy', $$v)
            },
            expression: "filters['enteredBy']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Updated By",
      "bodyStyle": "text-align: right",
      "field": "updatedBy",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['updatedBy']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'updatedBy', $$v)
            },
            expression: "filters['updatedBy']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action",
      "headerStyle": "width:14em"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('View Details'),
            expression: "'View Details'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised p-button-warning",
          attrs: {
            "icon": "pi pi-eye"
          },
          on: {
            "click": function($event) {
              return _vm.viewPOSSalesDetail(slotProps.data)
            }
          }
        }), _vm._v(" "), _c('Button', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.top",
            value: ('Print'),
            expression: "'Print'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "p-button-raised p-button-secondary",
          attrs: {
            "icon": "pi pi-print"
          },
          on: {
            "click": function($event) {
              return _vm.printPage(slotProps.data)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticClass: "pink--text"
  }, [_c('th', {
    staticClass: "title"
  }, [_vm._v("Totals")])])])], 2)], 1)]), _vm._v(" "), _c('Dialog', {
    on: {
      "cancel": _vm.cancel,
      "deleted": _vm.deleteReport
    },
    model: {
      value: (_vm.dialogShow),
      callback: function($$v) {
        _vm.dialogShow = $$v
      },
      expression: "dialogShow"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b7eec70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/pos/dublicatePosSalesEntry.vue
// module id = 2338
// module chunks = 0